import { useState, useEffect } from 'react';
import Axios from "axios";
import { GetJobRoles,  GetJobPosts,siteURL,updateStatus,GetCountries, Searchfilter,GetListOfVendorsByEmployeeID, UpdateCandidateClientStatus,  submittedCandidates, GetListOfUsersWithAdminByEmployeeID } from '../../apiconstants/constants';
import { Link, useLocation,useNavigate  } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../../helpers/loadingspinner';
import defaultimg from "../../assets/images/icons8-circled-user-male-skin-type-3-100.png";
import ConsultantLayout from '../../commonlayouts/consultantlayout';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Swal from 'sweetalert2';
import {Modal, Button } from 'react-bootstrap';
import Select from 'react-select';
import { useCountry } from '../../contexts/countrycodecontext.js';
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function substring_str(str) {
  if ((str === null) || (str === ' ' || str === undefined))
    return "";
  else
    str = str.toString();
  return str.substring(0, 20) + "...";
}

const InternalBench = () => {
  const [offset, setOffset] = useState(0);
  let query = useQuery();
  const [data, setData] = useState([]);
  const [perPage] = useState(25);
  const [pageCount, setPageCount] = useState(0);
  const [showIcon, setShowIcon] = useState('list');
  const [viewType, setViewType] = useState('list'); // 'grid' or 'list'  
  const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [jobRoles, setJobRoles] = useState([]);
  const [startDate, setStartDate] = useState(""); // Start date state
  const [endDate, setEndDate] = useState(""); // End date state
  const [showModal,setShowModal] = useState(false)
  const [showFilterModal,setShowFilterModal] = useState(false)
  const [candidateId, setCandidateId] = useState(null);
  const [hasNoData, setHasNoData] = useState(false);
  const { selectedCountry} = useCountry();
    const navigate = useNavigate();  
  const [vendorData, setVendorData] = useState([]);
  const [selectedUserGuid, setSelectedUserGuid] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null); 
  const [showDropdownModal, setShowDropdownModal] = useState(false);
  const [comments, setComments] = useState(""); // End date state
    const [jobPosts, setJobPosts] = useState([]);
const [selectedCandidateGuids, setSelectedCandidateGuids] = useState([]); // now only storing GUID strings
  const [selectAll, setSelectAll] = useState(false);
const [showSendMailModal, setShowSendMailModal] = useState(false);
const [submissionType, setSubmissionType] = useState(""); // "initial" or "partial"
  const [usersList, setUsersList] = useState([]);
  const token = localStorage.getItem("jwtToken");
          const [marketingStatus,setMarketingStatus] = useState([
      {statusID:"Active",statusName:"Active"},
      {statusID:"Hold",statusName:"Hold"},
      {statusID:"Pending",statusName:"Pending"},
    {statusID:"Deactivate",statusName:"Deactivate"}]);
const fetchJobPosts = async (jobRoleId, vendorGuid) => {
      setIsLoading(true);

      try {
        const response = await Axios.get(`${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        // Filter based on selected Job Role and Vendor (client)
        const filteredPosts = response.data?.filter((x)=>x.status =='Active')
            console.log(filteredPosts)
    
        setJobPosts(filteredPosts);
      } catch (error) {
        console.error("Error fetching job posts", error);
      } finally {
        setIsLoading(false);
      }
    };
    console.log("46",selectedCountry)
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
const fileName = "CandidatesList"; 
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };
let Guid="";
const handleCardClick = (guid) => {
     console.log("Checkbox clicked:", typeof guid);
  const stringGuid = String(guid);
  setSelectedCandidateGuids((prev) =>
    prev.includes(stringGuid)
      ? prev?.filter((id) => id != stringGuid)
      : [...prev, stringGuid]
  );
};

console.log("98",selectedCandidateGuids)
 
const handleSendEmail = () => {
  if (selectedCandidateGuids.length === 0) {
    Swal.fire("Please select at least one candidate.");
    return;
  }

  // Get full data objects
  const selectedCandidates = candidateData?.filter(candidate =>
    selectedCandidateGuids.includes(candidate.guid)
  );

  // Save to localStorage
  localStorage.setItem("selectedCandidateDetails", JSON.stringify(selectedCandidates));
   setShowSendMailModal(true);

};

 const handleSubmissionTypeConfirm = () => {
  if (!submissionType) {
    Swal.fire("Please select a submission type.");
    return;
  }
  const selectedCandidates = candidateData?.filter(candidate =>
    selectedCandidateGuids.includes(candidate.guid)
  );
  if (submissionType == "General Share") {
    window.location.href = "/Employer/ShareReportsCandidateDetailstoSubvendor";
  } else if (submissionType == "Partial Submission") {
    window.location.href = `/Employer/ShareBenchCandidateDettoRecruiter?guid=${selectedCandidates[0].guid}`;
  } else if (submissionType == "Initial Submission")  {
    window.location.href = "/Employer/ShareCandidatedetailstoSubVendor";
  }
};


const guid = localStorage.getItem("guid");
const employerGuid = localStorage.getItem("employerGuid")

const roleID = localStorage.getItem("roleID")
const appliedfilter = localStorage.getItem("candidateinternalbenchfilters")
if(roleID==3){
 Guid = employerGuid
}
else{
  Guid= guid
}

  const [selectedJobRoles, setSelectedJobRoles] = useState([]);
  const [workmodeOptions] = useState([
    { value: "", label: "Select Work Mode" },
    { value: "1", label: "Work from Home" },
    { value: "2", label: "Work from Office" },
    { value: "3", label: "Hybrid" },
  ]);
  //  const [candidateType,setCandidateType] = useState([
  //       {candidateTypeID:"Internal Bench",typeName:"Internal Bench"},
  //       {candidateTypeID:"C2C",typeName:"C2C"},
  //       {candidateTypeID:"W2",typeName:"W2"},
  //     {candidateTypeID:"1099",typeName:"1099"}]);
  const [selectedWorkMode, setSelectedWorkMode] = useState(null);
  const [countries, setCountries] = useState([]);
  
  const dateFilterOptions = [
    { value: "", label: "Select Date Filter" },
    { value: "Past 7 days", label: "Past 7 days" },
    { value: "Past 30 days", label: "Past 30 days" },
    { value: "This month", label: "This month" },
    { value: "Past 6 months", label: "Past 6 months" },
    { value: "Past 1 year", label: "Past 1 year" }, // Default case
     { value: "Past 2 years", label: "Past 2 years" }, // Default case
      { value: "Past 3 years", label: "Past 3 years" }, // Default case

  ];
  const [selectedDateFilter, setSelectedDateFilter] = useState(null);
const { register, handleSubmit, formState: { errors, isSubmitting }, setValue, reset } = useForm();
  
const safeValue = (value) => 
  (value === null || value === undefined || value === "null" || value === "undefined"||value === "null..." || value === "undefined...") 
    ? "" 
    : value;
 
  const [filters, setFilters] = useState({
    UserGuid: Guid,
    FullName: "",
    Email: "", 
    clientStatus: "",   
    jobRoleId: "",
    UpdatedDate: null,  
    VendorGuid:"",
    MarketingStatus: ""
    
  });

    const handleModalOpen = (guid,comments,clientStatus) => {
      console.log("123: comments :",comments, clientStatus,guid)
    setSelectedUserGuid(guid);
    setComments(comments);
    setSelectedStatus(clientStatus);
    setShowDropdownModal(true);
  };

  const handleModalClose = () => {
    setShowDropdownModal(false);
  };
   
    const handleFilterChange = (selectedOption) => {
      setSelectedDateFilter(selectedOption); 
      setFilters((prevFilters) => ({
        ...prevFilters,
        UpdatedDate: selectedOption.label, // ✅ Store label for API
      }));
    };
    
useEffect(() => {
  GetCandidateList();
  fetchJobRoles();
  fetchCountries();
  GetVendorsList();
   fetchJobPosts();
   GetUsersList();
}, [selectedCountry]); // Fetch data only once when the component mounts
const GetVendorsList = () => {
  setIsLoading(true);

  const GetapiUrl = GetListOfVendorsByEmployeeID.APIURL + `?UserGuid=${Guid}&CountryID=${selectedCountry}`;

  Axios.get(GetapiUrl)
    .then((result) => {
      setIsLoading(false);

      setVendorData(result.data);
    }).catch((error) => {
      console.log("Error" + error);
    });
};
const fetchJobRoles = async () => {
  const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
  try {
      const response = await Axios.get(getApiUrl);
      setJobRoles(response.data);
  } catch (error) {
    console.error("Error fetching job roles", error);
  }
};
const fetchCountries = async () => {
  try {
    const response = await fetch(GetCountries.APIURL,
      { headers: {    Authorization: `Bearer ${token}`,
    }}
    );
    const json = await response.json();
    
    // Format the countries for react-select
    const countryOptions = json.map((country) => ({
      value: country.countryID, // Assuming each country has a unique ID
      label: country.country, // Adjust based on API response structure
    }));

    setCountries([{ value: "", label: "Select Country" }, ...countryOptions]);
  } catch (error) {
    console.error("Error fetching countries:", error);
  }
};
const handleViewToggle = (type) => {
  setViewType(type);
  setShowIcon(type)
};


const jobRoleOptions = jobRoles.map((item) => ({
  value: item.jobRoleId,
  label: item.jobRole
}));
 const handleVendorChange = (event) => {
      setFilters((prevFilters) => ({
        ...prevFilters,
        VendorGuid: event.target.value, // ✅ Store as a string
      }));
    };
     const handleMarketingStatusChange= (event) => {
      setFilters((prevFilters) => ({
        ...prevFilters,
        MarketingStatus: event.target.value, // ✅ Store as a string
      }));
    };
const handleConfirmDeactivation = async () => {

   const params = {
      userGuid: Guid
    };

     await Axios.put(`${updateStatus.APIURL}?Guid=${candidateId}&isActive=${false}`, params,
      { headers: { Authorization: `Bearer ${token}` } }
     )
      .then((result) => 
        {
          if(result.data=='Candidate status updated successfully'){
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'DeActivated succesfully',
              showConfirmButton: false,
              timer: 2000,
            })
          }
          setCandidateData(prevData => prevData?.filter(candidate => candidate.guid !== candidateId));

        setIsLoading(false);
        setShowModal(false);

      })
      .catch((error) => {
        console.log("Error" + error);
      });
    }



const handleCancel = () => {
  setShowModal(false);
};

const handleCancelSearch = () => {
  setShowFilterModal(false);
};
 const GetCandidateList = async () => {
  setIsLoading(true);

  const GetapiUrl = Searchfilter.APIURL;
  console.log("210", selectedCountry);

  const savedFilters = localStorage.getItem("candidateinternalbenchfilters");
  let payload;
  let filtersObj;

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters);

    filtersObj = {
      ...parsedFilters,
      CountryID: selectedCountry,
       // <-- always set this
      UserGuid: Guid, // optional: enforce UserGuid from session
    };
 localStorage.setItem("candidateinternalbenchfilters", JSON.stringify(filtersObj));
    setFilters(filtersObj); // Optional: sync with UI filters
  } else {
    filtersObj = {
      UserGuid: Guid,
      CountryID: selectedCountry,
      MarketingStatus:"Active",
      // UpdatedDate:'This month'

      // CandidateType: "Internal Bench", // <-- always set this
    };
  }

  payload = {
    json: JSON.stringify(filtersObj),
    type: "internalcandidates",
  };

  try {
    const result = await Axios.post(GetapiUrl, payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setIsLoading(false);
    if (Array.isArray(result.data)) {
      setCandidateData(result.data);
    } else {
      setCandidateData([]);
    }
  } catch (error) {
    console.log("Error", error);
    setIsLoading(false);
  }
};

  const handleFilterSearch=()=>{
    setShowFilterModal(true);
    }
    const handleJobRoleChange = (selectedOptions) => {
      const jobRolesLabels = selectedOptions.map((opt) => opt.value).join(", "); 
      setFilters((prevFilters) => ({
        ...prevFilters,
        jobRoleId: jobRolesLabels, // ✅ Store as a string
      }));
    };
    
     const handleStatusChange = () => {
      console.log(selectedStatus)
      if(selectedStatus == null){
        Swal.fire("You can not submit without selecting any option!")
        return
      }
      setIsLoading(true)
      const payload ={
  "guid": selectedUserGuid,
  "status": selectedStatus,
  // "CandidateType":"Internal Bench",
  "comments": comments
      }
      Axios.post(`${UpdateCandidateClientStatus.APIURL}`,payload)
        .then((result) => {
          setIsLoading(false)
          if (result.data == 'Status updated successfully') {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Updated Successfully ',
              showConfirmButton: false,
              timer: 5000
            })
            GetCandidateList();
            setShowDropdownModal(false);
          }
        }
        )
    };
    
   const jobTitleOptions = jobPosts.map(job => ({
        value: job.jobPostID,
        label: `${job.title} - ${job.clientName}`,
        jobDescription: job.jobDescription // Store job description for later use
      }));

    
   
    
    
    const applyFilters = () => {
      const cleanedFilters = {

        ...filters,
        // PreferLocation: filters.PreferLocation === "Select Country" ? "" : filters.PreferLocation,
        WorkMode: filters.WorkMode === "Select Work Mode" ? "" : filters.WorkMode,
        UpdatedDate: filters.UpdatedDate === "Select Date Filter" ? "" : filters.UpdatedDate,
        CountryID: selectedCountry ,
        // CandidateType:"Internal Bench",
      };
    
      // Remove empty values
      let filteredData = Object.fromEntries(
        Object.entries(cleanedFilters)?.filter(
          ([key, value]) =>
            value !== "" &&
            value !== null &&
            !(Array.isArray(value) && value.length === 0)
        )
      );
       localStorage.setItem("candidateinternalbenchfilters", JSON.stringify(cleanedFilters));
      const payload = {
        json: JSON.stringify(filteredData),
        type: "internalcandidates",
      };
  
      console.log("Sending JSON:", payload);
      Axios
        .post(Searchfilter.APIURL, payload,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((response) => {
          console.log("Success:", response.data);
           setShowFilterModal(false)
          if(response.data == "No Data"){
            setCandidateData([]);
          }
          else {
          setCandidateData(response.data)
          }
         
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };
    const exportToCSV = async (fileName) => {
      setIsLoading(true); // Show loader while fetching data
    
      try {
        const GetapiUrl = Searchfilter.APIURL;
  
        const payload = {
          json: JSON.stringify({UserGuid: Guid,CountryID:selectedCountry}),
          type: "Reports",
    
        };
        const result = await Axios.post(GetapiUrl, payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setIsLoading(false);
    
        if (!result.data || result.data.length === 0) {
          alert("No data available for export.");
          return;
        }
    
        // Map API response to formatted data
        const customHeadings = result.data.map((item) => ({
          "Full Name": item.fullName,
          "Email": item.email,
          "Mobile Number": item.mobileNumber,
          "Gender": item.gender,
          "Address": item.address,
          "Date of Birth": item.dob,
          "Job Role": item.jobRoleName,
          "Marital Status": item.maritalStatus,
          "Technical Skill": item.technicalSkill,
          "Experience": item.experience,
          "Work Mode": item.workMode,
          "Prefer Location": item.preferLocation,
          "Profile Summary": item.profileSummery,
          "Bill Rate": item.billRate,
          "Work Authorization and Validity": item.workAuthorizationandValidity,
          "Employer Name": item.employerName,
          "SSN": item.ssn,
          "Passport No": item.passportNo,
          "Two References from Recent Project": item.tworefrencesfromrecentproject,
        }));
    
        // Convert JSON to sheet
        const ws = XLSX.utils.json_to_sheet(customHeadings);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    
        // Create Blob and trigger download
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
      } catch (error) {
        setIsLoading(false);
        console.error("Error exporting data:", error);
        alert("Failed to export data. Please try again.");
      }
    };
    
const handleUserSelect = async (benchSalesGuid) => {
  try {
    setIsLoading(true);
    const url = `${submittedCandidates.APIURL}/${benchSalesGuid}`;
    const response = await Axios.get(url,
      { headers: { Authorization: `Bearer ${token}` } }
    );
 if (Array.isArray(response.data)) {
      setCandidateData(response.data);
    } else {
      setCandidateData([]); // fallback
    }
    setSelectedUserGuid(benchSalesGuid); // optional: track selected user
  } catch (error) {
    console.error("Error fetching candidates:", error);
    Swal.fire("Error", "Failed to fetch submitted candidates", "error");
  } finally {
    setIsLoading(false);
  }
};

  useEffect(() => {
  const filteredData = candidateData?.filter(candidate => {
    const lowerSearchTerm = searchTerm?.toLowerCase()?.trim();

    // If no search term
    if (!lowerSearchTerm) {
        return true; 
    }

    // Determine search logic based on operators
    let searchTerms;
    let isAndSearch = false;
  
    if (lowerSearchTerm?.includes(' + ') || lowerSearchTerm?.includes(' and ')) {
        searchTerms = lowerSearchTerm?.split(/\s*\+\s*|\s+and\s+/);
        isAndSearch = true; // ALL terms must match
    } else if (lowerSearchTerm.includes(' or ')) {
        searchTerms = lowerSearchTerm?.split(/\s+or\s+/);
        isAndSearch = false; // At least one term must match
    } else {
        searchTerms = [lowerSearchTerm]; // Treat it as a single phrase
        isAndSearch = false;
    }
  
    // Convert search terms to lowercase and trim spaces
    searchTerms = searchTerms.map(term => term.trim());
  
    // Function to check if a field contains the *entire search term*
    const fieldMatchesTerm = (term) => {
        return [
            candidate.fullName,
            candidate.technicalSkill,
            candidate.jobRoleName,
            candidate.preferLocation,
            candidate.address,
            candidate.profileSummary,
            candidate.workAuthorizationandValidity,
            candidate.email
        ].some(field => field?.toLowerCase()?.includes(term)) ||
        (candidate.experience !== undefined && 
         (candidate.experience?.toString()?.includes(term) || `${candidate.experience} years`?.includes(term)));
    };
  
    // Apply AND / OR search logic
    const matchesSearch = isAndSearch
        ? searchTerms.every(fieldMatchesTerm) // Require all terms to match (AND search)
        : searchTerms.some(fieldMatchesTerm); // At least one term matches (OR search)

    return matchesSearch;
  });
  if (filteredData.length === 0) {
    setHasNoData(true);
    setData([]); // clear the UI
    setPageCount(0);
    return;
  } else {
    setHasNoData(false);
  }
  const getExperienceText = (experience) => {
    if (!experience) return '';
    return experience?.toLowerCase().includes('years') ? experience : `${experience} years`;
  };
    const slice = filteredData.slice(offset, offset + perPage);
    const items = viewType =='grid' ? slice.map((data) => {
             const isSelected = selectedCandidateGuids.includes(String(data.guid));

      return (
        <div className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3" key={data.guid}>
             <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 600, height: 600, borderRadius: 20 }}>
                <div className='card-header' style={{ background: "none", minHeight: 100 }}>
                  <div className='row'>
                    <div className='col-4'>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Profile Pic</Tooltip>)}>
                        <img alt="Profile Photo" src={(data?.photo === "null") || (data.photo === null )?defaultimg : data?.photoURL} style={{ height: 80, width: 80, borderRadius: '50%', border: '3px solid #00a7ac' }} />
                        {/* <img alt="Profile Photo" src={defaultimg} style={{ height: 80, width: 80, borderRadius: '50%', border: '3px solid #00a7ac' }} /> */}

                      </OverlayTrigger>
                    </div>
                    <div className='col-8'>
                 
                   <Link style={{ float:"right" }} to={"/Employer/ReplicateBenchCandidate?guid=" + data.guid}>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Replicate Candidate</Tooltip>)}>
                        <button style={{ background: "none", border: "none" }}><i className="fa fa-clone mt-2" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                      </OverlayTrigger>
                    </Link>
  
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>
                        <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.fullName}</b></p>
                      </OverlayTrigger>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Role</Tooltip>)}>
                        <h5 style={{ fontSize: 18 }}>{data.jobRoleName}</h5>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
                <div className="card-body" style={{minHeight:250}}>
                                 
                 
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>
                   <p style={{ fontSize: 14, display: 'flex', alignItems: 'center' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-phone" aria-hidden="true"></i> {data.mobileNumber} <a
        href={`tel:${data.mobileNumber}`}
        title="Click to Call"
        style={{ marginLeft: 10, color: "#00a7ac" }}
      >
        <i className="fas fa-phone"></i>
      </a> </p>
                  </OverlayTrigger>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-envelope" aria-hidden="true"></i> {data.email}</p>
                  </OverlayTrigger>               
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{ selectedCountry == 2 ? "PayRate" : "Current CTC" }</Tooltip>)}>
                  <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-dollar-sign" aria-hidden="true"></i>{safeValue(data.payRate)}</p>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>   { selectedCountry == 2 ? "BillRate" : "Expected CTC" } </Tooltip>)}>
                   <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-money-bill" aria-hidden="true"></i> {safeValue(data.billRate)}</p>
                 </OverlayTrigger>
                  {/* {data.preferLocation!==null && data.preferLocation!=="null" && (
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Country</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-map-marker" aria-hidden="true"></i> {data.preferLocation}  </p>
                  </OverlayTrigger>)} */}
                  {data.experience!==null && data.experience!=="null" && (
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Experience</Tooltip>)}>
        <p style={{ fontSize: 14 }}><i className="fa fa-briefcase icons" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} ></i> {getExperienceText(data.experience)}</p>
                  </OverlayTrigger>)}
                  {data.vendorName!==null && data.vendorName!=="null" && (
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Client Name</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user" aria-hidden="true"></i> {data.vendorName} </p>
                  </OverlayTrigger>)}
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Assigned Benchsaler</Tooltip>)}>
                                                          <p style={{ fontSize: 14, textAlign: 'justify' }}>
                                                          <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-user-tie" aria-hidden="true"></i>
                                                        {(data.assignBenchSaleUser)}
                                                        </p>
                                                           </OverlayTrigger>
                                                
                </div>
                <div   className={`card-footer text-center`} 
  style={{ background: "none" }}
>                 
  
                    <Link style={{ }} to={"/Employer/BenchViewCandidateDetailsByCandidateGUid?guid=" + data.guid}>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> View</Tooltip>)}>
                        <button style={{ background: "none", border: "none" }}><i className="fa fa-eye mr-2" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                      </OverlayTrigger>
                      
                    </Link>
            
                     <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">Select to Send Email</Tooltip>}>
  <span>
    <input
      type="checkbox"
      checked={isSelected}
      onChange={() => handleCardClick(data.guid)}
    />
  </span>
</OverlayTrigger>

                </div>
                
              </div>
        </div>
      )  })
      :
    
      <div className="col-12" style={{ overflowX: "auto", width: "100%" }}>
                            <table
  className="table"
  style={{
 //   minWidth: "100%",
    fontSize: "12px", // Reduced font size
    // tableLayout: "fixed",
    wordWrap: "break-word",
 


  }}
>
  <thead>
    <tr>
      <th style={{ padding: "4px" }}>Full Name</th>
      <th style={{ padding: "4px" }}>Assigned Benchsaler</th>
      <th style={{ padding: "4px" }}>Job Role</th>
    
      <th style={{ padding: "4px" }}>Mobile Number</th>
      <th style={{ padding: "4px" }}>Email</th>
      {/* <th style={{ padding: "4px" }}>Country</th> */}
      <th style={{ padding: "4px" }}>Experience</th>
   
     { selectedCountry == 2 ?<th style={{ padding: "4px" }}>PayRate</th>: <th style={{ padding: "4px" }}> Current CTC</th>}

     { selectedCountry == 2 ? <th style={{ padding: "4px" }}>Bill Rate</th>: <th style={{ padding: "4px" }}>Expected CTC</th>}
        <th style={{ padding: "4px" }}>Client Name</th>
      <th style={{ padding: "4px" }}>Actions</th>
    </tr>
  </thead>
  <tbody>
    {slice?.map((data, index) => {
        
const guidFromData = data.guid // handle invisible characters
        const isSelected = selectedCandidateGuids.includes(String(data.guid));

                return ( 
      <tr key={index}  style={{marginBottom:'2px'}}>
  

        <td style={{ padding: "4px" }}>{safeValue(data.fullName)}</td>
          <td style={{ padding: "4px" }}>{safeValue(data.assignBenchSaleUser)}</td>
        <td style={{ padding: "4px" }}>{safeValue(data.jobRoleName)}</td>
      
        <td style={{ padding: "4px" }}>{safeValue(data.mobileNumber)} <a
        href={`tel:${data.mobileNumber}`}
        style={{ marginLeft: 8, color: '#00a7ac' }}
        title="Click to Call"
      >
        <i className="fas fa-phone"></i>
      </a></td>
        <td style={{ padding: "4px"}}>{safeValue(data.email)}</td>
        {/* <td style={{ padding: "4px"}}>{data.preferLocation}</td> */}
        <td style={{ padding: "4px"}}>{safeValue(data.experience)}</td>
          <td style={{ padding: "4px" }}>{safeValue(data.payRate)}</td>
        <td style={{ padding: "4px" }}>{safeValue(data.billRate)}</td>
        <td style={{ padding: "4px" }}>{safeValue(data.vendorName)}</td>
    
        <td style={{ padding: "4px" }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "4px",
              justifyContent: "center",
            }}
          >
            {/* Example of responsive button grouping */}
            {[
            //   {
            //     icon: "fa-clone",
            //     tooltip: "Replicate Candidate",
            //     to: `/Employer/ReplicateBenchCandidate?guid=${data.guid}`,
            //   },
            //   {
            //     icon: "fa-edit",
            //     tooltip: "Edit",
            //     to: `/Employer/EditBenchCandidate?guid=${data.guid}`,
            //   },
              {
                icon: "fa-eye",
                tooltip: "View",
                to: `/Employer/BenchViewCandidateDetailsByCandidateGUid?guid=${data.guid}`,
              },
            //   {
            //     icon: "fa-share-alt",
            //     tooltip: "Share",
            //     to: `/Employer/ShareDetailstoVendor?guid=${data.guid}`,
            //   },
            //   {
            //     icon: "fa-envelope",
            //     tooltip: "Send Email",
            //     to: `/Employer/SendEmail?fullName=${data.fullName}`,
            //   },
            ].map((btn, i) => (
              <Link key={i} to={btn.to}>
                <OverlayTrigger
                  placement="bottom"
                  overlay={(props) => (
                    <Tooltip id="tooltip" {...props}>
                      {btn.tooltip}
                    </Tooltip>
                  )}
                >
                      
                  <button
                    style={{
                      background: "none",
                      border: "none",
                      padding: "4px",
                    }}
                  >
                    <i
                      className={`fa ${btn.icon}`}
                      aria-hidden="true"
                      style={{ fontSize: 14, color: "#00a7ac" }}
                    ></i>
                  </button>
                </OverlayTrigger>
              </Link>
            ))}
            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">Select to Send Email</Tooltip>}>
  <span>
    <input
      type="checkbox"
     checked={isSelected}
      onChange={() => handleCardClick(data.guid)}
    style={{
    width: 16,
    height: 16,
    cursor: "pointer",
    marginTop: '6px',
    marginLeft: '2px',
    accentColor: '#00a7ac !important', // ✅ ensures tick is visible in modern browsers
   appearance: 'auto !important' // ✅ resets to system default
  }}
    />
  </span>
</OverlayTrigger>
          </div>
        </td>
      </tr>
    )})}
       
  </tbody>
                            </table>

                            </div>
      
  

    setData(items);
    setPageCount(Math.ceil(filteredData.length / perPage));
  }, [offset, searchTerm,startDate,endDate,candidateData, perPage,viewType,selectedCandidateGuids]);
useEffect(() => {
  const savedFilters = JSON.parse(localStorage.getItem("candidateinternalbenchfilters"));

  // Optional: Check for existence and apply to state or variables if needed
  if (savedFilters) {
    console.log("Loaded filters:", savedFilters);

    // Example: if you have state like setSearchTerm, setStartDate, etc.
    if (savedFilters.searchTerm) {
      setSearchTerm(savedFilters.searchTerm);
    }
    if (savedFilters.startDate) {
      setStartDate(savedFilters.startDate);
    }
    if (savedFilters.endDate) {
      setEndDate(savedFilters.endDate);
    }
    // ... any other filters
  }

  // Continue with your filtering logic...

}, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setOffset(0); // Reset offset when search term changes to show results from the first page
  };

  const handleSelectAll = () => {
  setSelectAll(!selectAll);
  if (!selectAll) {
    // Select all candidate GUIDs
    const allGuids = candidateData.map(candidate => String(candidate.guid));
    setSelectedCandidateGuids(allGuids);
  } else {
    // Deselect all
    setSelectedCandidateGuids([]);
  }
};

  const GetUsersList = () => {
    setIsLoading(true);

    const GetapiUrl = GetListOfUsersWithAdminByEmployeeID.APIURL + `?EmployeeGuid=${Guid}`;

    Axios.get(GetapiUrl,
      { headers: { Authorization: `Bearer ${token}` } }
    )
      .then((result) => {
        setIsLoading(false);
           if (Array.isArray(result.data)) {
       const filteredUsers = result.data?.filter(
          (user) =>
            (user.usertype === "Bench Sales" || user.roleID === 2) &&
            user.countryMappings?.includes(selectedCountry)
        );
        setUsersList(filteredUsers);
      } else {
        // If "No records found" or any non-array result
        setUsersList([]);
      }
      }).catch((error) => {
        console.log("Error" + error);
         setUsersList([]);
      });
  };


  const handleRefresh=()=>{
      setSearchTerm("")
    setFilters({
       UserGuid: Guid,
    FullName: "",
    Email: "", 
    clientStatus: null,   
    jobRoleId: "",
    UpdatedDate: null,  
    VendorGuid:null,
    // CandidateType:"",
   jobTitleID: null
    });
     reset({
    vendorCompanyName: "", // field name in `register()`
    clientStatus: "",       // field name in `register()`
    candidateTypeID: ""
  });
     localStorage.removeItem("candidateinternalbenchfilters");
    GetCandidateList();
  }

  return (
    <ConsultantLayout>
      <div className='container-fluid mt-3'>
      

<div className="responsive-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  {/* Left: Title */}
  <div>
    <h2 style={{ color: "#00a7ac", marginLeft: '10px' }}>Bench-Sales</h2>
  </div>

  {/* Right: Dropdown + Toggle buttons */}
  <div style={{ display: 'flex', alignItems: 'center' }}>
    {/* <Select
      options={usersList?.map((user) => ({
        value: user.guid,
        label: user.firstName
      }))}
      onChange={(selectedOption) => handleUserSelect(selectedOption?.value)}
      placeholder="Select Bench Sales User"
        styles={{
          control: (provided) => ({
            ...provided,
            fontSize: '14px', // Change this to your desired size
            marginRight:20,
            width:250
          }),
          menu: (provided) => ({
            ...provided,
            fontSize: '14px',
          }),
          option: (provided) => ({
            ...provided,
            fontSize: '14px',
          }),
          placeholder: (provided) => ({
            ...provided,
            fontSize: '14px',
          }),
        }}
    /> */}
    {/* <OverlayTrigger placement="bottom" overlay={<Tooltip>Bench Sales Reports</Tooltip>}>
  <button
    className="btn btn-primary mr-3"
    onClick={() => navigate("/Employer/ViewBenchSalesReports")}  // 👈 navigate to new screen
    style={{ backgroundColor: "#00a7ac" }}
  >
<i className="fas fa-users" style={{ color: '#fff', cursor: 'pointer' }}></i>
  </button>
</OverlayTrigger>
   <OverlayTrigger placement="bottom" overlay={<Tooltip>Bench Sales Statistics</Tooltip>}>
  <button
    className="btn btn-primary mr-3"
    onClick={() => navigate("/Employer/BenchSalesStat")}  // 👈 navigate to new screen
    style={{ backgroundColor: "#00a7ac" }}
  >
<i className="fas fa-chart-bar" style={{ color: '#fff', cursor: 'pointer' }}></i>
  </button>
</OverlayTrigger> */}
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Add Internal Candidate</Tooltip>)}>
                    <Link to="/Employer/AddInternalCandidate">
                      <button className="btn btn-primary mr-3" btn-ype="button"><i className="fa fa-plus"></i></button>
                    </Link>
                     </OverlayTrigger>
                <Link to={"/Employer/AddInternalCandidateFromDocument?guid="+ guid}>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Import candidate through PDF/Docx </Tooltip>)}>
                        <button className="btn btn-primary mr-3"><i className="fa fa-file" aria-hidden="true"></i></button>
                      </OverlayTrigger>
                 </Link>



    {showIcon === 'grid' && (
      <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
        <button
          className="btn btn-primary mr-2"
          onClick={() => handleViewToggle('list')}
          style={{ backgroundColor: "#00a7ac" }}
        >
          <i className="fa fa-th-list" style={{ color: '#fff', cursor: 'pointer' }}></i>
        </button>
      </OverlayTrigger>
    )}
    {showIcon === 'list' && (
      <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
        <button
          className="btn btn-primary"
          onClick={() => handleViewToggle('grid')}
          style={{ backgroundColor: "#00a7ac" }}
        >
          <i className="fa fa-th" style={{ color: '#fff', cursor: 'pointer' }}></i>
        </button>
      </OverlayTrigger>
    )}

      
  </div>
</div>


        <div>
 
        <div className="row d-flex justify-content-between mt-3">
  <div className="col">
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Search by Name or Technical Skill or Email or Role or Country or Address</Tooltip>
    )}>
      <input
        type="text"
        placeholder="Search by Name or Technical Skill or Email or Role or Address"
        className="form-control mt-3"
        id="searchcss2"
        value={searchTerm}
        onChange={handleSearch}
      />
    </OverlayTrigger>
  </div>

  <div className="col-auto align-self-end">
   
    <Link>
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>{ appliedfilter == null ? "Apply Filter" : "Filter Applied" }</Tooltip>
    )}>
    <button className="btn btn-primary mt-3 mr-3" onClick={handleFilterSearch} style={{height:50}}type="button">
    <i className="fas fa-filter"></i>    { appliedfilter == null ? "Apply Filter" : "Filter Applied" }
    </button>
    </OverlayTrigger>
    </Link>
    <Link>
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Reset</Tooltip>
    )}>
    <button className="btn btn-primary mt-3" onClick={handleRefresh} style={{height:50}}type="button">
      <i className="fas fa-sync"></i> Reset Filter
    </button>
    </OverlayTrigger>
    </Link>
   
  </div>
</div>



              </div>
        <hr />
    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '20px' }}>

       <div>
                <input 
                  type="checkbox" 
                  checked={selectAll} 
                  onChange={handleSelectAll} 
                  style={{ marginRight: '10px' }} 
                />
                <span style={{marginRight: '10px',  color: '#333', }}>Select All</span>
            </div>
      {selectedCandidateGuids.length > 0 && (
  <button className="btn btn-primary" onClick={handleSendEmail} style={{ height: 45,backgroundColor: "#00a7ac" }}>
     
    Send Email {selectedCandidateGuids.length} <i className="fas fa-arrow-right" style={{ marginLeft: 5 }}></i>
  </button>
)}
 </div>
     {isLoading ? (
            <center><LoadingSpinner /></center>
          ) : (
            <>
   {hasNoData ? (
    <div className="pb-5 text-center">
      <img
        title="No Data"
        className="no-data-img"
        alt="no-data-img"
        src={nodataimg}
        style={{ height: 370 }}
      />
    </div>
  ) : (
    <div className="row mt-5 pb-3">
      {data}
    </div>
  )}
  
  
            </>
          )}
        {
          candidateData.length > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }

<Modal show={showModal} style={{textAlign:"center"}} onHide={handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"#00a7ac"}}>Confirm Deactivation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to deactivate this candidate?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>No</Button>
          <Button variant="primary" onClick={handleConfirmDeactivation}>Yes</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showFilterModal} style={{ textAlign: 'center'}}  dialogClassName="custom-modal"  onHide={handleCancelSearch}>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"#00a7ac"}}>Filters </Modal.Title>
         </Modal.Header>
        <Modal.Body>
          <div className='row'>
                <div className='col-6'>  
                    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Client name</Tooltip>)}>
                    <select
                                            {...register("vendorCompanyName", { required: "Client Name Required" })}
                                            className={`form-control mt-3 ${errors.vendorCompanyName ? 'is-invalid' : ''}`}
                                           style={{height:50 ,borderRadius:15,fontSize:12}}
                                            onChange={handleVendorChange}
                                            value={filters.VendorGuid || ""}
                                        >
                                            <option value="">Select Client Name</option>
                                            {vendorData.map((vendor, index) => (
                                                <option key={index} value={vendor.vGuid}>{vendor.vendorName} - {vendor.vendorCompanyName}</option>
                                            ))}
                    </select>  
                    </OverlayTrigger>
                     {/* <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Candidate Status</Tooltip>)}>
                    <select  {...register("clientStatus")} className={`form-control mt-3`}
                    style={{height:50 ,borderRadius:15,fontSize:12}} 
                      value={filters.clientStatus || ""}
                       onChange={(event) =>
    setFilters((prevFilters) => ({
      ...prevFilters,
      clientStatus: event.target.value, // ✅ Store as a string
    }))
  }>
                <option value="">Select Candidate Status</option>
                    <option value="New">New</option>
                    <option value="Submitted">Submitted</option>
                    <option value="In-Progress">In-Progress</option>
                    <option value="Selected">Selected</option>
                    <option value="Rejected">Rejected</option>
                    </select>
                                         </OverlayTrigger>                */}
                                
                  

                    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Select Date Filter</Tooltip>)}>    
                    
                                    <Select
                        options={dateFilterOptions}
                        placeholder="Select Date Filter"
                        value={dateFilterOptions.find(option => option.label === filters.UpdatedDate) || null}
                        onChange={handleFilterChange}
                        className="mt-3"
                        styles={{
                            control: (provided) => ({
                            ...provided,
                            height: 50,
                            borderRadius: 10,
                            fontSize: "12px",
                            }),
                            placeholder: (provided) => ({
                            ...provided,
                            textAlign: "left",
                            fontSize: "12px",
                            }),
                            singleValue: (provided) => ({
                            ...provided,
                            textAlign: "left",
                            fontSize: "12px",
                            
                            }),
                        }}
                        />
                    </OverlayTrigger>
                       <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Marketing Status</Tooltip>)}>
                    <select
                                            {...register("MarketingStatus")}
                                            className={`form-control mt-3`}
                                           style={{height:50 ,borderRadius:15,fontSize:12}}
                                            onChange={handleMarketingStatusChange}
                                            value={filters.MarketingStatus || ""}
                                        >
                                            <option value="">Select Marketing Status</option>
                                            {marketingStatus.map((status, index) => (
                                                <option key={index} value={status.statusName}>{status.statusName}</option>
                                            ))}
                    </select>  
                    </OverlayTrigger>
                   
                </div>
                <div className='col-6'>
             
      {/* <OverlayTrigger
            placement="bottom"
            overlay={(props) => <Tooltip id="tooltip" {...props}>Select Job Title</Tooltip>}
          >
            <div className="">
              <Select
  options={jobTitleOptions}
  placeholder="Select Job Title"
  className="mt-3"
value={
    jobTitleOptions.find(option => option.value === filters.jobTitleID) || null
  }  
  onChange={(selectedOption) => {
    setFilters(prev => ({
      ...prev,
      jobTitleID: selectedOption ? selectedOption.value : null
    }));
  }}
  styles={{
    control: (provided) => ({
      ...provided,
      height: 50,
      borderRadius: 10,
      fontSize: "12px",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
  }}
/>
            </div>
                     </OverlayTrigger> */}
              
              <Select
            options={jobRoleOptions}
            isMulti
            placeholder="Select Job Roles"
            className="mt-3"
            value={jobRoleOptions?.filter(option => 
              filters.jobRoleId.split(", ").includes(option.value.toString()) // ✅ Convert stored string back to array
            )}
            onChange={handleJobRoleChange}
            styles={{
              control: (provided) => ({
                ...provided,
                height: 115,
                borderRadius: 10,
                fontSize: "12px",
              }),
              placeholder: (provided) => ({
                ...provided,
                textAlign: "left",
                fontSize: "12px",
              }),
              singleValue: (provided) => ({
                ...provided,
                textAlign: "left",
                fontSize: "12px",
              }),
            }}
          />

        
          
                </div>
          </div>
         
        </Modal.Body>
        <Modal.Footer style={{marginTop:100}}>
        <Button variant="primary" onClick={handleRefresh}>
      <i className="fas fa-sync" style={{ marginRight: "5px" }}></i> Reset
    </Button>
          <Button variant="primary" onClick={applyFilters}>Apply</Button>
          <Button variant="secondary" onClick={handleCancelSearch}>Cancel</Button>

        </Modal.Footer>
      </Modal>
       <Modal show={showDropdownModal} onHide={handleModalClose} centered dialogClassName="custom-inline-width">
                <Modal.Header closeButton>
                  <Modal.Title style={{fontSize:20}}>Update Candidate Status</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{width:700}}>
                  {["New","Submitted","In-Progress", "Interview Scheduled","On Hold","Selected","Rejected" ].map((status) => (
                    <Button
                    key={status}
                     size="sm"
                     variant={selectedStatus === status ? "primary" : "outline-primary"} 
                    className="w-100 mb-2"
                    onClick={() => setSelectedStatus(status)}
                  >
                    {status}
                  </Button>
                  
                  ))}
                   <ReactQuill
                                  value={comments}
                                  onChange={setComments}
                                  placeholder="Comments"
                                  style={{height:180, marginBottom: 20}}
                                />
                      {/* <textarea type="text" style={{height:100}} title='' placeholder='Comments'
            onChange={(e)=>setComments(e.target.value)} 
        value =  {safeValue(comments)}
           className={`form-control basic-form mt-3 `} ></textarea> */}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => handleStatusChange()}>
                    Submit
                  </Button>
                  <Button variant="secondary" onClick={handleModalClose}>
                    Cancel
                  </Button>
                </Modal.Footer>
              </Modal>
       <Modal show={showSendMailModal} onHide={() => setShowSendMailModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title style={{ color: "#00a7ac" }}>Select Submission Type</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {/* General Share - always visible */}
    <div className="form-check text-start">
      <input
        className="form-check-input"
        type="radio"
        name="submissionType"
        value="General Share"
        checked={submissionType === "General Share"}
        onChange={() => setSubmissionType("General Share")}
        id="generalShare"
      />
      <label className="form-check-label" htmlFor="generalShare">
        General Share
      </label>
    </div>

    {/* Apply for a Job - always visible */}
    <div className="form-check text-start">
      <input
        className="form-check-input"
        type="radio"
        name="submissionType"
        value="Initial Submission"
        checked={submissionType === "Initial Submission"}
        onChange={() => setSubmissionType("Initial Submission")}
        id="initialSubmission"
      />
      <label className="form-check-label" htmlFor="initialSubmission">
        Apply for a Job
      </label>
    </div>

    {/* Candidate Submission - only visible for single candidate */}
    {selectedCandidateGuids.length === 1 && (
      <div className="form-check mt-2 text-start">
        <input
          className="form-check-input"
          type="radio"
          name="submissionType"
          value="Partial Submission"
          checked={submissionType === "Partial Submission"}
          onChange={() => setSubmissionType("Partial Submission")}
          id="partialSubmission"
        />
        <label className="form-check-label" htmlFor="partialSubmission">
          Candidate Submission
        </label>
      </div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="primary" onClick={handleSubmissionTypeConfirm}>
      Proceed
    </Button>
    <Button variant="secondary" onClick={() => setShowSendMailModal(false)}>
      Cancel
    </Button>
  </Modal.Footer>
</Modal>
       <style>
{`
  .custom-inline-width {
    max-width: 700px !important;
    width: 100%;
  }
`}
</style>
      </div>
    </ConsultantLayout>
  );
}






export default InternalBench